<template>
    <div class="pd20x flex1">
        <Loading v-if="loading"></Loading>
        <addCourseBook :visible="visible" @close="visible = false" :data="currentItem" @update="getData"></addCourseBook>
        <!-- 文件上传弹窗 -->
        <a-modal
            title="下载文件"
            :visible="fileUploadVisible"
            @ok="handleModalOk"
            @cancel="handleModalCancel"
            width="600px"
        >
            <div style="display:flex;align-items:center; margin-bottom: 20px;">
                <a-upload 
                    name="file" 
                    accept=".pdf,.PDF" 
                    :customRequest="customRequest" 
                    @change="handleFileChange" 
                    :fileList="paperPdf" 
                >
                    <a-button> <a-icon type="upload" />上传PDF</a-button>
                </a-upload>
            </div>
            <!-- PDF预览区域 -->
            <div v-if="previewUrl" class="pdf-preview">
                <h4>PDF预览:</h4>
                <embed :src="previewUrl" type="application/pdf" width="100%" height="400px">
            </div>
        </a-modal>
        <div class="h100pct ofA">
            <div class="filter pd20x mb10x">
                <div>
                  科目名称 : {{name}}
                  <a-tag color="pink">1
                  </a-tag>
                  <a-tag color="red">2
                  </a-tag>
                  <a-tag color="orange">3
                  </a-tag>
                  <a-tag color="green">4
                  </a-tag>
                  <a-tag color="cyan">5
                  </a-tag>
                  <a-tag color="blue">6
                  </a-tag>
                  <a-tag color="purple">7
                  </a-tag>
                </div>
                <div>
                    <a-button type="primary" @click="addItem">添加</a-button>
                </div>
            </div>
            <a-table
                    :columns="columns"
                    :data-source="result"
                    :pagination="pagination"
                    :rowKey="'id'"
                    @change="changePage"
            >
                <template slot="name" slot-scope="text, record">
                  <div class="name">
                    {{record.title}}
                    <span class="count" v-if="record.task_type == 1">[历年真题]</span>
                    <span class="count red" v-if="record.task_type == 2">[其他资源]</span>
                    <span class="count juice" v-if="record.task_type == 3">[VIP题库]</span>
                    <span class="count">[{{ record.total_count }}]</span>
                  </div>
                </template>
                <template slot="bookIn" slot-scope="text, record">
                  <div v-for="(item,index) in record.bookIn" :key="index" >
                    <a-tag v-if="item>0" :color="colorList[index]">
                      {{ item }}
                    </a-tag>
                  </div>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a-space>
                        <a-button type="primary" style="margin-right:10px" @click="$router.push({path:`/home/addTask`, query: {id: record.id}})">设置</a-button>
                        <a-button type="primary" ghost style="margin-right:10px" @click="$router.push({path:`/home/EditTask`, query: {id: record.id, task_type: record.task_type, cate_id: filter.cate_id}})">修改</a-button>
                        <a-button type="primary" ghost style="margin-right:10px" @click="deleteItem(record.id)">删除</a-button>
                        <a-button :type="record.pdf ? 'primary' : 'default'" :style="record.pdf ? {marginRight: '10px', backgroundColor: '#d03343', borderColor: '#d03343'} : {marginRight: '10px'}" @click="openFileUpload(record)">文件</a-button>
                    </a-space>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
    const columns = [
        {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
            width: 400,
            align:'center'
        },{
            title: '导入数量',
            dataIndex: 'bookIn',
            scopedSlots: { customRender: 'bookIn' },
            width: 400,
            align:'center'
        }, {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    import * as http from '@/libs/analysis'
    import { getTaskList, delTask, editTask, BaseUrl, uploadImg, saveTaskPdf } from '@/libs/api'
    import addCourseBook from '@/components/analysis/addCourseBook'
    import Loading from '@/components/loading'
    import moment from 'moment'
    export default {
        name: 'courseBook',
        components: { Loading, addCourseBook },
        data(){
            return{
                result: [],
                columns,
                visible: false,
                loading: true,
                currentItem: [],
                name: '',
                classId : '',
                total: 0,
                filter:{
                    cate_id: 0,
                    keywords:''
                },
                pagination:{
                    page: 1,
                    total: 0,
                    size: '15',
                    pageSize: 15
                },
                colorList: ['pink', 'red', 'orange', 'green', 'cyan', 'blue', 'purple'],
                fileUploadVisible: false,
                currentRecord: null,
                previewUrl: null,
                paperPdf: []
            }
        },
        mounted(){
          if (this.$route.query.bind_catid)
            this.filter.cate_id = this.$route.query.bind_catid;
          if (this.$route.query.name)
            this.name = this.$route.query.name;
          this.$nextTick(()=>{
            this.getData()
          })
        },
        methods:{
            moment,
            changePage({current}){
                this.pagination.page = current
                this.getData()
            },
            setShow(index , id){
                this.loading = true
                http.show_course_book({id:id}).then(res=>{
                    this.loading = false;
                    this.result[index]['show'] = !this.result[index]['show'];
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            getData(){
                this.result = [];
                this.loading = true;
                let request= {
                  ...this.filter,...this.pagination,
                  user_id:this.$store.state.userInfo.id
                }
                getTaskList(request).then(res=>{
                    this.loading = false
                    this.result = res.list
                    this.total = res.count
                    this.pagination.total = res.count
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            handleChange(){

            },
            handleFileChange(info) {
              let fileList = [...info.fileList];
              fileList = fileList.slice(-1);
              fileList = fileList.map(file => {
                if (file.response) {
                  file.url = file.response.url;
                }
                return file;
              });
              this.paperPdf = fileList;
            },
            customRequest(data) {
              let formData = new FormData();
              formData.append('file', data.file);
              uploadImg(formData).then(res => {
                //更新到卷子上
                saveTaskPdf({
                    id: this.currentRecord.id,
                    pdf: res.fileUrl
                }).then(res=>{
                    this.paperPdf[0].status = 'done';
                    this.previewUrl = res.fileUrl;
                    this.getData();
                    this.$message.success('pdf上传成功');
                },error=>{
                    console.log(error);
                    this.$message.error('上传失败，请重试');
                })
              }, error => {
                console.log(error);
                this.$message.error('上传失败，请重试');
              });
            },
            openFileUpload(record){
                this.currentRecord = record;
                // 清空之前的上传记录
                this.paperPdf = [];
                // 如果当前记录有PDF文件，加载它作为预览
                if (record.pdf) {
                    this.previewUrl = record.pdf;
                } else {
                    this.previewUrl = null;
                }
                this.fileUploadVisible = true;
            },
            handleModalOk(){
                this.fileUploadVisible = false;
                // 清除预览URL和上传记录
                if (this.previewUrl) {
                    URL.revokeObjectURL(this.previewUrl);
                    this.previewUrl = null;
                }
                // 清空上传记录
                this.paperPdf = [];
            },
            handleModalCancel(){
                this.fileUploadVisible = false;
                // 清除预览URL和上传记录
                if (this.previewUrl) {
                    URL.revokeObjectURL(this.previewUrl);
                    this.previewUrl = null;
                }
                // 清空上传记录
                this.paperPdf = [];
            },
            onSelectChange(){

            },
            addItem(){
                this.currentItem = [];
                this.visible = true;
            },
            deleteItem(id){
                let _this = this
                this.$confirm({
                    title: '删除原始素材，该操作不可逆，确认删除吗?',
                    centered: true,
                    onOk() {
                        delTask({id}).then(res=>{
                          _this.getData()
                        },error=>{
                          console.log(error)
                        })
                    },
                });
            },
            hideModal(){

            }
        }
    }
</script>
<style lang="less" scoped>
  .count{
    font-size: 10px;
    padding-left: 10px;
    color: #5482e1;
    font-weight: 600;
  }
  .red{
    color: #d03343;
  }
  .juice{
    color: #FF5722;
  }
  .pdf-preview{
    margin-top: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
    background-color: #f9f9f9;
  }
  .pdf-preview h4{
    margin-top: 0;
    margin-bottom: 10px;
    color: #333;
  }
</style>
